<template>
    <Modal v-model="modal"
           :title="$t((isCreate?'创建':'编辑')+'项目')"
           :mask-closable="false"
           @on-cancel="cancel"
           @submit.native.prevent>
        <Form ref="form"
              :model="formData"
              :rules="rules"
              :label-width="120">
            <FormItem :label="$t('项目名称')+'：'"
                      prop="orgName">
                <Input style="width: 80%"
                       :placeholder="$t('项目名称')"
                       :maxlength="32"
                       v-model="formData.orgName" />
            </FormItem>
            <FormItem :label="$t('描述')+'：'">
                <Input v-model="formData.description"
                       type="textarea"
                       style="width: 80%;"
                       :autosize=" { minRows: 4, maxRows: 8 }"
                       :maxlength="200"
                       :placeholder="$t('描述')"
                       class="slbist-item" />
            </FormItem>
        </Form>
        <div slot="footer">
            <Button type="text"
                    @click="cancel">{{$t('取消')}}</Button>
            <Button type="primary"
                    :loading="loading"
                    @click="submit">{{loading ? $t('提交中'):$t('保存')}}</Button>
        </div>
    </Modal>
</template>

<script>
import API from '@/service/api'
export default {
    inject: ['reload'],
    name: 'createproject',
    data () {
        return {
            modal: false,
            loading: false,
            isCreate: true,
            formData: {
                orgSid: '',
                orgName: '',
                description: ''
            },
            rules: {
                orgName: [
                    { required: true, message: this.$t('该字段不能为空'), trigger: 'change' },
                    {
                        trigger: 'blur',
                        validator: async (rule, value, callback) => {
                            // 唯一性验证
                            if (this.isCreate) {
                                const result = await this.uniqueName(value)
                                if (!result) {
                                    return callback(new Error(this.$i18n.t('项目名称不能重复')))
                                } else {
                                    return callback()
                                }
                            }
                        }
                    }]
            }
        }
    },
    methods: {
        async uniqueName (name) {
            const data = await this.axios.get(this.urlFormat(API.GET_ACCESS_PROJECTS_CHECK_NAME + '?name=' + name, false))
            return !data
        },
        openModal (data) {
            this.formData = {
                orgSid: '',
                orgName: '',
                description: ''
            }
            this.isCreate = true
            if (data) {
                this.isCreate = false
                this.formData.orgSid = data.orgSid
                this.formData.orgName = data.orgName || ''
                this.formData.description = data.description || ''
            }
            this.modal = true
        },
        // 提交
        submit () {
            const params = {
                orgName: this.formData.orgName,
                description: this.formData.description
            }
            this.$refs.form.validate((v) => {
                if (v) {
                    this.loading = true
                    if (this.isCreate) {
                        // 创建
                        this.axios.post(this.urlFormat(API.ACCESS_PROJECTS, false), params).then(res => {
                            this.loading = false
                            // this.$emit('refresh')
                            this.cancel()
                            this.reload()
                        }).catch(e => {
                            this.loading = false
                        })
                    } else {
                        // 编辑
                        params.orgSid = this.formData.orgSid
                        this.axios.put(this.urlFormat(API.ACCESS_PROJECTS, false), params).then(res => {
                            this.loading = false
                            this.$emit('refresh')
                            this.cancel()
                        }).catch(e => {
                            this.loading = false
                        })
                    }
                }
            })
        },
        // 清空数据
        cancel () {
            this.$refs.form.resetFields()
            this.formData = {
                orgSid: '',
                orgName: '',
                description: ''
            }
            this.modal = false
        }
    }
}
</script>
